module.exports = __webpack_public_path__ + "img/fast_check_in-w.svg";